import {
  RECEIVE_VIP_HOME_PAGE,
  RECEIVE_INFLUENCER_NAMES,
  RECEIVE_VIP_INFLUENCER_VIDEOS,
  REQUEST_VIP_INFLUENCER_VIDEOS,
  REQUEST_GAME_VIDEOS,
  RECEIVE_GAME_VIDEOS,
  RECEIVE_INFLUENCER_VIDEO_NOTE,
  REQUEST_INFLUENCER_VIDEO_NOTES,
  RECEIVE_INFLUENCER_VIDEO_NOTES,
  REQUEST_INFLUENCER_DAILY_TRACKINGS_DATA,
  RECEIVE_INFLUENCER_DAILY_TRACKINGS_DATA,
  REQUEST_VIDEO_URL,
  RECEIVE_VIDEO_URL,
  REQUEST_DROPBOX_VIDEO_URL,
  RECEIVE_DROPBOX_VIDEO_URL,
} from "./home_actions";

const nullState = {
  influencerCount: 0,
  videoCount: 0,
  categories: [],
  countries: [],
  influencers: [],
  topics: [],
  trendingVideos: [],
  trendingInfluencers: [],
  recentVideos: [],
  loadingVideos: false,
  loadingGame: false,
  gameVideos: [],
  gameCount: 0,
  loadingNotes: false,
  influencerVideoNotes: [],
  loadingCounts: false,
  stats: {
    average_likes: null,
    average_views: null,
    average_video_length: null,
  },
  gameProducts: [],
  gameProductPictures: [],
  loaded_for: null,
  engagementIndexData: {
    average_views_per_video: null,
    average_engagement_index: null,
    influencer_performance_index: null,
  },
  loadingEngagementIndexData: false,
  video_url: null,
  loadingVideoUrl: false,
  dropbox_video: null,
  loadingDropBoxVideoUrl: false,
};

const vipReducer = (state = nullState, payload = {}) => {
  const {
    type,
    data,
    influencers,
    recentVideos,
    influencerVideoNotes,
    note,
    engagementIndexData,
    video_url,
    dropbox_video,
  } = payload;
  switch (type) {
    case RECEIVE_VIP_HOME_PAGE:
      return { ...state, ...data };
    case RECEIVE_INFLUENCER_NAMES:
      return { ...state, influencers };
    case RECEIVE_VIP_INFLUENCER_VIDEOS:
      return { ...state, loadingVideos: false, recentVideos };
    case REQUEST_VIP_INFLUENCER_VIDEOS:
      return { ...state, loadingVideos: true };
    case REQUEST_GAME_VIDEOS:
      return { ...state, loadingGame: true };
    case RECEIVE_GAME_VIDEOS:
      return { ...state, ...data, loadingGame: false };
    case REQUEST_INFLUENCER_VIDEO_NOTES:
      return { ...state, loadingNotes: true };
    case RECEIVE_INFLUENCER_VIDEO_NOTES:
      return { ...state, influencerVideoNotes, loadingNotes: false };
    case RECEIVE_INFLUENCER_VIDEO_NOTE:
      const index = state.influencerVideoNotes.findIndex(
        ({ _id }) => _id === note._id
      );
      const notes = [...state.influencerVideoNotes];
      if (index !== -1) {
        notes[index] = note;
      } else {
        notes.push(note);
      }
      return { ...state, influencerVideoNotes: notes, loadingNotes: false };
    case REQUEST_INFLUENCER_DAILY_TRACKINGS_DATA:
      return { ...state, loadingEngagementIndexData: true };
    case RECEIVE_INFLUENCER_DAILY_TRACKINGS_DATA:
      return {
        ...state,
        engagementIndexData,
        loadingEngagementIndexData: false,
      };
    case REQUEST_VIDEO_URL:
      return { ...state, loadingVideoUrl: false };
    case RECEIVE_VIDEO_URL:
      return { ...state, video_url, loadingVideoUrl: true };
    case REQUEST_DROPBOX_VIDEO_URL:
      return { ...state, loadingDropBoxVideoUrl: false };
    case RECEIVE_DROPBOX_VIDEO_URL:
      return { ...state, dropbox_video, loadingDropBoxVideoUrl: true };
    default:
      return state;
  }
};

export default vipReducer;
